export const ToothConditionTypes = {
  ToothConditionTypeTreatmentPlanned: "ToothConditionTypeTreatmentPlanned",
  ToothConditionTypeDiagnosis: "ToothConditionTypeDiagnosis",
  ToothConditionTypeExistingTreatment: "ToothConditionTypeExistingTreatment",
  ToothConditionTypeTreatmentCompleted: "ToothConditionTypeTreatmentCompleted",
};
